import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { PermissionResource } from './types'

// The permission catalog (which resources exist, the access that enables each, and what each
// requires), owned by the API; static for a session, so it is read once
export const PERMISSION_RESOURCES_QUERY: TypedDocumentNode<
  { permissionResources: PermissionResource[] },
  Record<string, never>
> = gql`
  query PermissionResources {
    permissionResources {
      key access requires actions
    }
  }
`
